import { FC } from "react";
import components from "./ApplComponents";

interface IInputDataItem {
  label: string;
  value: string;
}

const InputDataItem: FC<IInputDataItem> = ({ label, value }) => {
  return components[label](label, value);
  // return (
  //   <li className="info-piece">
  //     <div className="piece-title">{formatCalcName(label)}</div>
  //     <div className="piece-value">{value}</div>
  //   </li>
  // );
};

export default InputDataItem;
